"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-screen-arrow.tsx
var ScreenArrow = function ScreenArrow(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M2.33337 5.19434H13.6667",
    stroke: "currentColor",
    strokeWidth: "1.4"
  }), (0, _preact.h)("path", {
    d: "M8.33337 13.6663H11.1667C12.5474 13.6663 13.6667 12.5471 13.6667 11.1663V4.83301C13.6667 3.4523 12.5474 2.33301 11.1667 2.33301H4.83337C3.45266 2.33301 2.33337 3.4523 2.33337 4.83301V7.99967",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round"
  }), (0, _preact.h)("path", {
    d: "M4.33337 8H5.66671",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round"
  }), (0, _preact.h)("path", {
    d: "M8.33337 8H11.6667",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round"
  }), (0, _preact.h)("path", {
    d: "M8.33337 11H11.6667",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round"
  }), (0, _preact.h)("path", {
    d: "M5.78076 12.8569V10.2856H3.20946",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), (0, _preact.h)("path", {
    d: "M5.78076 10.2852L2.95233 13.1136",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var _default = ScreenArrow;
exports.default = _default;